export default __webpack_public_path__ + "static/media/home_input_bg.75662ff2.png";